<template>
  <div>
    <banners :banners="banners" :title="title" />
    <div class="landing-page">
      <div class="landing-page__container">
        <div class="landing-page__description">
          <h2 class="landing-page__description-title">
            {{ $t('landing_pages.iphone_15.first_title') }}
          </h2>
          <p
            class="landing-page__description-subtitle"
            v-html="$t('landing_pages.iphone_15.first_description')"
          ></p>
        </div>
      </div>
      <shelf
        :shelf-products="shelf"
        :case-device-id="5648"
        :fixed-price="99.9"
        :change-device-image-slug="['iphone1314', 'galaxys24']"
        :use-cache="false"
        :first-shelf="true"
      />
      <div class="landing-page__container">
        <div
          v-if="$isBrStore || isSubstore"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <div class="landing-page__description">
            <h2 class="landing-page__description-title">
              {{ $t('landing_pages.iphone_15.second_title') }}
            </h2>
            <p
              class="landing-page__description-subtitle"
              v-html="$t('landing_pages.iphone_15.second_description')"
            ></p>
          </div>

          <div class="landing-page__wrapper-container">
            <div class="landing-page__wrapper">
              <div class="landing-page__gallery">
                <a
                  v-for="(minibanner, index) in minibanners"
                  :key="index"
                  class="landing-page__gallery-item"
                  :href="minibanner.redirectLink"
                  rel="noopener"
                >
                  <img :src="minibanner.src" :alt="minibanner.alt" />
                </a>
              </div>
            </div>
          </div>

          <div class="landing-page__description">
            <h2 class="landing-page__description-title">
              {{ $t('landing_pages.iphone_15.third_title') }}
            </h2>
          </div>

          <div class="landing-page__wrapper-container">
            <div class="landing-page__wrapper">
              <div class="landing-page__gallery">
                <a
                  v-for="(comparativeMinibanner,
                  index) in comparativeMinibanners"
                  :key="index"
                  class="landing-page__gallery-item"
                  :href="comparativeMinibanner.redirectLink"
                >
                  <img
                    :src="comparativeMinibanner.src"
                    :alt="comparativeMinibanner.alt"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="landing-page__description">
          <h2 class="landing-page__description-title">
            {{ $t('landing_pages.iphone_15.fourth_title') }}
          </h2>
          <p
            class="landing-page__description-subtitle"
            v-html="$t('landing_pages.iphone_15.fourth_description')"
          ></p>
        </div>

        <div class="landing-page__hero-banner">
          <img :src="lastHeroBanner" alt="Samsung S24" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shelf from '~/components/pages/shelf/Shelf.vue'
import Banners from '~/components/pages/banners/Banners.vue'
export default {
  components: {
    Shelf,
    Banners,
  },
  data() {
    return {
      title: 'Samsung S24',
    }
  },
  computed: {
    storeInfo() {
      return this.$store.getters.storeInfo
    },
    shelf() {
      return {
        id: 4087,
        label: this.$t('landing_pages.iphone_15.shelf_title'),
        see_more: this.$isBrStore
          ? 'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24'
          : this.isSubstore
          ? '/capinhas-para-celular/samsung-galaxy-s24'
          : 'https://www.gocase.com/smartphone-cases/iphone-15-pro-max-nl',
        type: 'custom',
      }
    },
    isGlobalStore() {
      return !(
        this.$isBrStore || this.$store.getters.storeInfo?.substore === 'us'
      )
    },
    isSubstore() {
      return this.$store.getters.storeInfo?.substore === 'us'
    },
    banners() {
      const bannersBr = [
        {
          name: 'Samsung S24',
          link_url:
            'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24',
          desktop_image:
            'https://ik.imagekit.io/gocase/slides/8786/desktop/Galaxy-S24-Banner_Desktop.png',
          mobile_image:
            'https://ik.imagekit.io/gocase/slides/8786/mobile/Galaxy-S24-Banner.jpg',
        },
      ]

      const bannersSubstore = [
        {
          name: 'Samsung S24',
          link_url:
            'https://us.gocase.com/capinhas-para-celular/samsung-galaxy-s24',
          desktop_image:
            'https://static-production.gocase.com.br/slides/8804/desktop/Galaxy_S24_Banner_INTER_Desktop_-_Copia.png?1706022495',
          mobile_image:
            'https://static-production.gocase.com.br/slides/8804/mobile/Galaxy_S24_Banner_INTER_MOBILE_-_Copia.png?1706022495',
        },
      ]

      const bannersGlobal = [
        {
          name: 'Samsung S24',
          link_url:
            'https://www.gocase.com/smartphone-cases/iphone-15-pro-max-nl',
          desktop_image:
            'https://static-goengines.gocase.com.br/qr-img/21566416661397071694465713780.png',
          mobile_image:
            'https://static-goengines.gocase.com.br/qr-img/0064984388292863571694465951329.jpeg',
        },
      ]

      return this.$isBrStore
        ? bannersBr
        : this.isSubstore
        ? bannersSubstore
        : bannersGlobal
    },
    heroBanner() {
      const heroBannerBr =
        'https://static-goengines.gocase.com.br/qr-img/82174971890847391693591717156.jpeg'

      const heroBannerSubstore =
        'https://static-goengines.gocase.com.br/qr-img/088545233461409411695411750334.jpeg'

      const heroBannerGlobal = ''

      return this.$isBrStore
        ? heroBannerBr
        : this.isSubstore
        ? heroBannerSubstore
        : heroBannerGlobal
    },
    minibanners() {
      const minibannersBr = [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/250706009010793541705436649624.png',
          alt: 'Slim Air',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24?case_device=antiimpactoslimair-galaxys24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/85205783190482691705436688869.png',
          alt: 'Slim Guard',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/74664632343068841705436665707.png',
          alt: 'Slim Guard [MAGSAFE]',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/6772781739061181705436615776.png',
          alt: 'Slim Black',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24',
        },
      ]

      const minibannersSubstore = [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/61604519939344151705947672208.png',
          alt: 'Shockproof Clear',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/samsung-galaxy-s24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/289782457130760341705947770972.png',
          alt: 'Crystal Glow MagSafe',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/samsung-galaxy-s24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/90367186571552491705947790875.png',
          alt: 'Shockproof Black',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/samsung-galaxy-s24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/65503609584388541705947756053.png',
          alt: 'UltraGuard',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/samsung-galaxy-s24',
        },
      ]

      return this.$isBrStore ? minibannersBr : minibannersSubstore
    },
    comparativeMinibanners() {
      const comparativeMinibannersBr = [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/80211449778554881705438139748.png',
          alt: 'Shockproof Clear',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24/?case_device=antiimpactoslimair-galaxys24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/80211449778554881705438139748.png',
          alt: 'Guard Clear [Magsafe]',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24/',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/72834551810767991705438224974.png',
          alt: 'Slim Black',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24/',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/337868162000023231705438233720.png',
          alt: 'Gocase Duo',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/samsung-galaxy-s24/',
        },
      ]

      const comparativeMinibannersSubstore = [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/72425319558571831706027205647.png',
          alt: 'Slim Air',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/samsung-galaxy-s24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/79139208889370291706027251662.png',
          alt: 'Crystal Glow MagSafe',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/samsung-galaxy-s24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/76505428214341941706027267160.png',
          alt: 'Shockproof Black',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/samsung-galaxy-s24',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/445284375793024271706027230349.png',
          alt: 'UltraGuard',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/samsung-galaxy-s24',
        },
      ]

      return this.$isBrStore
        ? comparativeMinibannersBr
        : comparativeMinibannersSubstore
    },
    miniHeroBannersGlobal() {
      return [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/93126643586916621694466624627.jpeg',
          alt: 'Slim Black',
          redirectLink:
            'https://www.gocase.com/smartphone-cases/iphone-15-pro-max-nl',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/458242823893533441694466604884.jpeg',
          alt: 'Slim Air',
          redirectLink:
            'https://www.gocase.com/smartphone-cases/iphone-15-pro-max-nl',
        },
      ]
    },
    lastHeroBanner() {
      const lastHeroBannerBr =
        'https://static-goengines.gocase.com.br/qr-img/51370423381627051705436560598.jpeg'

      const lastHeroBannerSubstoreAndGLobal =
        'https://static-goengines.gocase.com.br/qr-img/51370423381627051705436560598.jpeg'

      return this.$isBrStore
        ? lastHeroBannerBr
        : lastHeroBannerSubstoreAndGLobal
    },
  },
  head() {
    return {
      title: this.title,
    }
  },
}
</script>

<style lang="scss" scoped>
.landing-page {
  background-color: #fcfdf7;
  position: relative;
  min-height: 399px;
  color: #000 !important;

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__description {
    text-align: center;
    margin: 42px 15px 5px 15px;

    &-title {
      font-size: 36px;
      margin: 0px !important;
    }

    &-subtitle {
      font-size: 20px;
      font-weight: 300;
      margin: 5px 0 5px 0 !important;
      max-width: 800px;
    }
  }

  &__hero-banner {
    width: 100%;

    img {
      overflow-clip-margin: content-box;
      overflow: clip;
      width: 100%;
    }
  }
}

.landing-page__wrapper-container {
  position: relative;

  .landing-page__wrapper {
    overflow-x: auto;

    .landing-page__gallery {
      display: flex;
      flex-flow: row nowrap;
      gap: 15px;

      .landing-page__gallery-item {
        cursor: pointer;
        flex-shrink: 0;

        img {
          width: 100%;
        }
      }
    }
  }
}

img {
  overflow-clip-margin: content-box;
  overflow: clip;
}
.landing-page__wrapper::-webkit-scrollbar {
  display: none;
}

.landing-page__wrapper {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.landing-page__gallery-item:first-child {
  padding-left: 15px;
}

.landing-page__gallery-item:nth-last-child(1) {
  padding-right: 15px;
}

@media (min-width: 768px) {
  .landing-page {
    &__description {
      text-align: center;
      margin: 42px 0px 5px 0px;

      &-title {
        font-size: 40px;
      }

      &-subtitle {
        font-size: 24px;
        font-weight: 300;
        margin: 5px 0 5px 0 !important;
        max-width: 800px;
      }
    }
  }
  .landing-page__container {
    width: 1170px;
    margin-right: auto;
    margin-left: auto;
  }

  .landing-page__wrapper-container {
    position: relative;
    margin: 0px;

    .landing-page__wrapper {
      .landing-page__gallery {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;

        .landing-page__gallery-item {
          cursor: pointer;
          flex-shrink: 1;

          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
